export default [
    //FOR Branch User to View the PO========================================================================
    {
        subject: "po",
        key: "viewPOSubmittedToMD", //this is the parameter found in the url /form/:key 
        pageTitle: "PO Submitted To MD",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Submitted To MD",
                userId: "",
            },
            filterEndpoint: "getPOByUserIdAndStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        },
    },
    {
        subject: "po",
        key: "viewPOApproveMD", //this is the parameter found in the url /form/:key 
        pageTitle: "PO Approved By MD",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Approved PO",
                userId: "",
            },
            filterEndpoint: "getPOByUserIdAndStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        },
    },



    //------------------------------------------------------------------------------------------------------
    //FOR Finance Manager========================================================================
    {
        subject: "po",
        key: "PO Pending Approval", //this is the parameter found in the url /form/:key 
        pageTitle: "PO Pending Approval",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "PO Pending Approval",
            },
            filterEndpoint: "getPOByStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        },
    },
    {
        subject: "po",
        key: "Submitted To MD", //this is the parameter found in the url /form/:key 
        pageTitle: "PO Submitted To MD",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Submitted To MD",
            },
            filterEndpoint: "getPOByStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        },
    },



    {
        subject: "po",
        key: "poApprovedByMD", //this is the parameter found in the url /form/:key 
        pageTitle: "PO Approved By MD",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Approved PO",
            },
            filterEndpoint: "getPOByStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        },
    },
  
    {
        subject: "po",
        key: "poApprovedByMDForRevised", //this is the parameter found in the url /form/:key 
        pageTitle: "PO Approved By MD",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "purchaseOrders",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Approved PO", 
            },
            additionalData: { 
                // poStatus: "Submitted To MD", 
                userId: "" // we set this on the fly
            },
            filterEndpoint: "getPOByStatusAndCanRevise",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        },
    },

    {
        subject: "po",
        key: "poRevised", //this is the parameter found in the url /form/:key 
        pageTitle: "PO Revised",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "purchaseOrders",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Approved PO", 
            },
            additionalData: { 
                // poStatus: "Submitted To MD", 
                userId: "" // we set this on the fly
            },
            filterEndpoint: "getPOByStatusAndCannotRevise",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        },
    },

    {
        subject: "po",
        key: "canceledPO", //this is the parameter found in the url /form/:key 
        pageTitle: "Canceled PO",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "purchaseOrders",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Cancel PO", 
            },
            // additionalData: { 
            //     // poStatus: "Submitted To MD", 
            //     userId: "" // we set this on the fly
            // },
            filterEndpoint: "getCanceledPO",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        },
    },


    {
        subject: "po",
        key: "PO Rejected By FM", //this is the parameter found in the url /form/:key 
        pageTitle: "PO Rejected By FM",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Submitted To MD",
            },
            filterEndpoint: "getPOByStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        },
    },
    {
        subject: "po",
        key: "PORejectedByMD", //this is the parameter found in the url /form/:key 
        pageTitle: "PO Rejected By MD",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "PO Rejected By MD",
            },
            filterEndpoint: "getPOByStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        },
    },
    {
        subject: "po",
        key: "poToClose", //this is the parameter found in the url /form/:key 
        pageTitle: "PO To Closed",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Approved PO",
            },
            filterEndpoint: "getPOByStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        },
    },
    {
        subject: "po",
        key: "CLOSED PO", //this is the parameter found in the url /form/:key 
        pageTitle: "CLOSED PO",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "CLOSED PO",
            },
            filterEndpoint: "getPOByStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        },
    },
    //------------------------------------------------------------------------------------------
    //FOR Managing Director========================================================================
    
    {
        subject: "po",
        key: "submittedToMD", //this is the parameter found in the url /form/:key 
        pageTitle: "PO Pending Approval",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Submitted To MD",
            },
            filterEndpoint: "getPOByStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        },
    },
    {
        subject: "po",
        key: "APPROVED PO", //this is the parameter found in the url /form/:key 
        pageTitle: "APPROVED PO",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Approved PO",
            },
            filterEndpoint: "getPOByStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        },
    },
    {
        subject: "po",
        key: "PO Rejected By MD", //this is the parameter found in the url /form/:key 
        pageTitle: "PO Rejected By MD",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "PO Rejected By MD",
            },
            filterEndpoint: "getPOByStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        },
    },
    //------------------------------------------------------------------------------------------
]